import { default as colorMappings } from '@upsales/components/Utils/colorMappings';
import type { Pin, PinBase, PinSpecifics, AccountAddress } from './MapPinTypes';

const getGoogleMapsUrl = ({ address, city, zipcode, municipality, state }: AccountAddress) => {
	const street = address && address.split(',')[0];

	let addressString = '';
	if (street && street.toLowerCase().indexOf('box') === -1) {
		addressString += street + ', ';
		addressString += zipcode ? zipcode + ' ' : '';
	}
	addressString += city ? city + ', ' : '';
	addressString += municipality ? municipality + ', ' : '';
	addressString += state ?? '';

	return 'https://www.google.com/maps/place/' + encodeURIComponent(addressString);
};

const accountAddressPinBase = (accountAddress: AccountAddress) => {
	const url = getGoogleMapsUrl(accountAddress);
	const pinBase: PinBase<AccountAddress> = {
		backgroundColor: '#f5a624',
		border: '#f19623',
		color: colorMappings.get('white'),
		iconText: accountAddress.label,
		iconColor: 'white',
		clickable: true,
		events: {
			click: [
				{
					alwaysTrigger: true,
					handler: (event, pin) => {
						window.open(url, '_blank');
					}
				}
			]
		}
	};
	return pinBase;
};

const getSpecificsFromAccountAddress = (accountAddress: AccountAddress) => {
	if (!accountAddress.longitude || !accountAddress.latitude) {
		return null;
	}

	const pinSpecifics: PinSpecifics<AccountAddress> = {
		longitude: accountAddress.longitude,
		latitude: accountAddress.latitude,
		address: accountAddress.address || '',
		zipcode: accountAddress.zipcode || '',
		city: accountAddress.city || '',
		name: accountAddress.label || '',
		data: accountAddress
	};
	return pinSpecifics;
};

const createAccountAddressPin = (accountAddress: AccountAddress) => {
	const accountAddressPinSpecifics = getSpecificsFromAccountAddress(accountAddress);
	if (!accountAddressPinSpecifics) {
		return null;
	}

	const accountAddressPin: Pin<AccountAddress> = {
		...accountAddressPinBase(accountAddress),
		...accountAddressPinSpecifics
	};

	return accountAddressPin;
};

export default createAccountAddressPin;
